import React from "react"
import { Badge, Button } from "reactstrap"

const AccessoriesUsageHeader = ({
  handleAddNewClick,
  handleRefresh,
  resetParams,
  isRefetching,
  hasActiveFilters,
  total,
}) => {
  return (
    <div className="d-flex align-items-center justify-content-between mb-3">
      <h5 className="mb-0 card-title">
        Total <Badge className="badge-soft-info">{total ?? 0}</Badge>
      </h5>

      <div className="d-flex gap-2">
        <Button
          color="primary"
          onClick={handleAddNewClick}
          title="Add New Accessories Company"
        >
          Add New
        </Button>

        <Button color="light" onClick={handleRefresh} title="Refresh List">
          <i className={`mdi mdi-refresh ${isRefetching ? "mdi-spin" : ""}`} />
        </Button>

        {hasActiveFilters && (
          <Button
            color="danger"
            onClick={resetParams}
            title="Reset Active Filters"
          >
            Reset Filters
          </Button>
        )}
      </div>
    </div>
  )
}

export default AccessoriesUsageHeader
